import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from 'react';
import { useNavigate } from 'react-router-dom';
import Hls from 'hls.js';
import './Boclips.css';
import boclipsLogo from '../../assets/boclips.png';
import mdsLogo from '../../assets/Logo.svg';

const BEST_FOR_OPTIONS = [
  { id: 'explainer', label: 'Explainer' },
  { id: 'application', label: 'Application' },
  { id: 'tutorial', label: 'Tutorial' },
  { id: 'discovery', label: 'Discovery' },
  { id: 'experience', label: 'Experience' },
];

const CEFR_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

const SORT_OPTIONS = [
  { value: '', label: 'Relevance' },
  { value: 'RELEASE_DATE', label: 'Release date (newest)' },
];

const TABS = [
  { id: 'videos', label: 'Videos' },
  { id: 'collections', label: 'Collections' },
  { id: 'playlists', label: 'My playlists' },
  { id: 'channels', label: 'Channels' },
  { id: 'highlights', label: 'Highlights' },
];

const MODAL_TABS = [
  { id: 'watch', label: 'Watch' },
  { id: 'learning', label: 'Learning outcomes' },
  { id: 'assessment', label: 'Assessment' },
  { id: 'transcript', label: 'Transcript' },
];

// ─── Icons ─────────────────────────────────────────────────────────────────

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);

const GridIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </svg>
);

const ListIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <rect x="3" y="4" width="18" height="2.5" rx="1" />
    <rect x="3" y="10.75" width="18" height="2.5" rx="1" />
    <rect x="3" y="17.5" width="18" height="2.5" rx="1" />
  </svg>
);

const PlayIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="white" style={{ filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.4))' }}>
    <path d="M8 5v14l11-7z" />
  </svg>
);

const CloseIcon = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

const FilterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
);

const ShareIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

const LinkIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);

const FolderIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
  </svg>
);

// ─── Helpers ────────────────────────────────────────────────────────────────

const formatDuration = (duration) => {
  if (!duration) return null;
  if (typeof duration === 'number') {
    const m = Math.floor(duration / 60);
    const s = Math.floor(duration % 60);
    return `${m}:${String(s).padStart(2, '0')}`;
  }
  if (typeof duration === 'string') {
    if (duration.startsWith('PT')) {
      const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?/);
      if (match) {
        const h = parseInt(match[1] || 0, 10);
        const min = parseInt(match[2] || 0, 10);
        const sec = Math.floor(parseFloat(match[3] || 0));
        if (h > 0) return `${h}:${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
        return `${min}:${String(sec).padStart(2, '0')}`;
      }
    }
    return duration;
  }
  return null;
};

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return '';
  }
};

const secondsToIsoDuration = (totalSeconds) => {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  if (m === 0) return `PT${r}S`;
  if (r === 0) return `PT${m}M`;
  return `PT${m}M${r}S`;
};

const getVideoThumbnail = (video) => {
  if (!video) return null;
  const directFields = ['thumbnail', 'thumbnailUrl', 'thumbnail_url', 'image', 'poster', 'posterImage', 'coverImage', 'cover'];
  for (const field of directFields) {
    if (video[field]) return video[field];
  }
  const pbThumb = video.playback?._links?.thumbnail;
  if (pbThumb?.href) {
    if (pbThumb.templated && pbThumb.href.includes('{thumbnailWidth}')) {
      return pbThumb.href.replace('{thumbnailWidth}', '640');
    }
    return pbThumb.href;
  }
  if (video._links) {
    const linkTypes = ['thumbnail', 'image', 'poster', 'cover', 'coverImage', 'thumbnailImage'];
    for (const lt of linkTypes) {
      const link = video._links[lt];
      if (!link) continue;
      if (typeof link === 'string') return link;
      if (link.href) {
        if (link.templated && link.href.includes('{thumbnailWidth}')) return link.href.replace('{thumbnailWidth}', '640');
        return link.href;
      }
    }
  }
  if (video.links?.thumbnail) {
    const t = typeof video.links.thumbnail === 'string' ? video.links.thumbnail : video.links.thumbnail.href;
    if (t?.includes('{thumbnailWidth}')) return t.replace('{thumbnailWidth}', '640');
    return t;
  }
  if (video.links?.image) {
    return typeof video.links.image === 'string' ? video.links.image : video.links.image.href;
  }
  return null;
};

const getVideoStreamUrl = (video) => {
  if (!video) return null;
  const pbStream = video.playback?._links?.hlsStream;
  if (pbStream?.href) return pbStream.href;
  const linkStream = video._links?.hlsStream;
  if (linkStream?.href) return linkStream.href;
  return null;
};

const getVideoDuration = (video) => {
  if (video.playback?.duration) return formatDuration(video.playback.duration);
  if (video.duration) return formatDuration(video.duration);
  return null;
};

const extractVideos = (data) => {
  if (!data) return [];
  if (data._embedded?.videos && Array.isArray(data._embedded.videos)) return data._embedded.videos;
  if (data.page && Array.isArray(data.page)) return data.page;
  if (Array.isArray(data)) return data;
  if (data.videos && Array.isArray(data.videos)) return data.videos;
  return [];
};

const extractCollections = (data) => {
  if (!data) return [];
  if (data._embedded?.collections) return data._embedded.collections;
  if (Array.isArray(data)) return data;
  return [];
};

const extractChannels = (data) => {
  if (!data) return [];
  if (data._embedded?.channels) return data._embedded.channels;
  if (Array.isArray(data)) return data;
  return [];
};

const extractHighlights = (data) => {
  if (!data) return [];
  if (data._embedded?.highlights) return data._embedded.highlights;
  if (Array.isArray(data.highlights)) return data.highlights;
  return [];
};

const extractSubjects = (data) => {
  if (!data) return [];
  if (data._embedded?.subjects) return data._embedded.subjects;
  return [];
};

/** Debounce fast-changing values (e.g. filters) so we don’t hammer the API on every slider tick. */
function useDebouncedValue(value, ms) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
}

// ─── Main ─────────────────────────────────────────────────────────────────

const Boclips = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const hlsRef = useRef(null);
  const isInitialMount = useRef(true);
  const playbackSegmentStart = useRef(null);
  const suggestionTimer = useRef(null);

  const [currentUser, setCurrentUser] = useState(null);
  const [activeTab, setActiveTab] = useState('videos');

  const [searchQuery, setSearchQuery] = useState('');
  const [videos, setVideos] = useState([]);
  const [videosLoading, setVideosLoading] = useState(false);
  const [videoOpenLoading, setVideoOpenLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchPage, setSearchPage] = useState(0);

  const [subjects, setSubjects] = useState([]);
  const [subjectsLoading, setSubjectsLoading] = useState(false);
  const [educationLevels, setEducationLevels] = useState([]);
  const [subjectSearch, setSubjectSearch] = useState('');
  const [selectedSubjectIds, setSelectedSubjectIds] = useState([]);
  const [selectedEduLevels, setSelectedEduLevels] = useState([]);
  const [selectedCefr, setSelectedCefr] = useState([]);
  const [bestForLabels, setBestForLabels] = useState([]);
  const [sortBy, setSortBy] = useState('');
  const [durationMinSec, setDurationMinSec] = useState(0);
  const [durationMaxSec, setDurationMaxSec] = useState(3600);
  const [channelFilterId, setChannelFilterId] = useState(null);
  const [channelFilterName, setChannelFilterName] = useState('');

  const [channels, setChannels] = useState([]);
  const [channelsLoading, setChannelsLoading] = useState(false);
  const [channelsPage, setChannelsPage] = useState(0);

  const [discoverCollections, setDiscoverCollections] = useState([]);
  const [myCollections, setMyCollections] = useState([]);
  const [collectionsLoading, setCollectionsLoading] = useState(false);
  const [collectionDetail, setCollectionDetail] = useState(null);
  const [collectionDetailLoading, setCollectionDetailLoading] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [newDesc, setNewDesc] = useState('');

  const [myPlaylists, setMyPlaylists] = useState([]);
  const [playlistsLoading, setPlaylistsLoading] = useState(false);
  const [playlistDetailModal, setPlaylistDetailModal] = useState(null);
  const [playlistVideos, setPlaylistVideos] = useState([]);
  const [playlistVideosLoading, setPlaylistVideosLoading] = useState(false);
  const [plModalOpen, setPlModalOpen] = useState(false);
  const [plFormMode, setPlFormMode] = useState('create');
  const [plEditingId, setPlEditingId] = useState(null);
  const [plFormTitle, setPlFormTitle] = useState('');
  const [plFormDesc, setPlFormDesc] = useState('');

  const [highlightsQuery, setHighlightsQuery] = useState('');
  const [highlights, setHighlights] = useState([]);
  const [highlightsLoading, setHighlightsLoading] = useState(false);

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videoToken, setVideoToken] = useState(null);
  const [modalTab, setModalTab] = useState('watch');
  const [learningOutcomes, setLearningOutcomes] = useState(null);
  const [assessmentQs, setAssessmentQs] = useState(null);
  const [transcript, setTranscript] = useState(null);
  const [modalExtraLoading, setModalExtraLoading] = useState(false);

  const [addToPlaylistId, setAddToPlaylistId] = useState('');

  const [viewMode, setViewMode] = useState('list');
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const apiBase = useMemo(
    () => (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001').replace(/\/$/, ''),
    [],
  );
  const adminKey = process.env.REACT_APP_ADMIN_API_KEY;

  const authHeaders = useMemo(
    () => ({
      'x-api-key': adminKey || '',
      'Content-Type': 'application/json',
    }),
    [adminKey],
  );

  const fetchJson = useCallback(
    async (path, options = {}) => {
      if (!adminKey) throw new Error('API key not configured');
      const { signal, headers: optHeaders, ...rest } = options;
      const res = await fetch(`${apiBase}${path}`, {
        ...rest,
        signal,
        headers: { ...authHeaders, ...optHeaders },
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message || err.error || res.statusText || 'Request failed');
      }
      const text = await res.text();
      return text ? JSON.parse(text) : null;
    },
    [apiBase, adminKey, authHeaders],
  );

  useEffect(() => {
    const loadUser = async () => {
      try {
        let userDataStr = sessionStorage.getItem('currentUser');
        if (!userDataStr) {
          userDataStr = localStorage.getItem('boclips_currentUser');
          if (userDataStr) {
            sessionStorage.setItem('currentUser', userDataStr);
            localStorage.removeItem('boclips_currentUser');
          }
        }
        if (!userDataStr) {
          setError('Please log in to access Boclips content');
          setTimeout(() => navigate('/'), 2000);
          return;
        }
        const userData = JSON.parse(userDataStr);
        const u = {
          id: userData.id,
          email: userData.email,
          name: userData.name || userData.full_name,
        };
        setCurrentUser(u);
      } catch {
        setError('Failed to load user data');
      }
    };
    loadUser();
  }, [navigate]);

  const uid = currentUser?.id;
  const qUser = uid ? `userId=${encodeURIComponent(uid)}` : '';

  const searchPageRef = useRef(0);
  useEffect(() => {
    searchPageRef.current = searchPage;
  }, [searchPage]);

  const searchParamsRef = useRef({});
  searchParamsRef.current = {
    searchQuery,
    selectedSubjectIds,
    channelFilterId,
    selectedEduLevels,
    selectedCefr,
    bestForLabels,
    sortBy,
    durationMinSec,
    durationMaxSec,
  };

  const searchAbortRef = useRef(null);
  const searchSeqRef = useRef(0);
  const collectionsSeqRef = useRef(0);
  const playlistsSeqRef = useRef(0);
  const channelsSeqRef = useRef(0);
  const highlightsSeqRef = useRef(0);

  useEffect(
    () => () => {
      searchAbortRef.current?.abort();
    },
    [],
  );

  useEffect(() => {
    if (activeTab !== 'videos') searchAbortRef.current?.abort();
  }, [activeTab]);

  const filterSignature = useMemo(
    () =>
      JSON.stringify({
        selectedSubjectIds,
        channelFilterId,
        selectedEduLevels,
        selectedCefr,
        bestForLabels,
        sortBy,
        durationMinSec,
        durationMaxSec,
      }),
    [
      selectedSubjectIds,
      channelFilterId,
      selectedEduLevels,
      selectedCefr,
      bestForLabels,
      sortBy,
      durationMinSec,
      durationMaxSec,
    ],
  );

  const debouncedFilterSignature = useDebouncedValue(filterSignature, 380);
  const filtersPendingSync = filterSignature !== debouncedFilterSignature;

  const prevFilterSig = useRef(null);

  useEffect(() => {
    if (!uid || activeTab !== 'videos') return;
    if (prevFilterSig.current === null) {
      prevFilterSig.current = filterSignature;
      return;
    }
    if (prevFilterSig.current !== filterSignature) {
      prevFilterSig.current = filterSignature;
      setSearchPage(0);
    }
  }, [uid, activeTab, filterSignature]);

  const loadSubjects = useCallback(async () => {
    if (!uid) return;
    setSubjectsLoading(true);
    try {
      const data = await fetchJson(`/providers/boclips/subjects?${qUser}`);
      setSubjects(extractSubjects(data));
    } catch (e) {
      console.warn('Subjects load failed', e);
      setSubjects([]);
    } finally {
      setSubjectsLoading(false);
    }
  }, [fetchJson, uid, qUser]);

  const loadEducationLevels = useCallback(async () => {
    if (!uid) return;
    try {
      const data = await fetchJson(`/providers/boclips/education-levels?${qUser}`);
      const list = data?._embedded?.educationLevels || data?.educationLevels || data;
      setEducationLevels(Array.isArray(list) ? list : []);
    } catch {
      setEducationLevels([]);
    }
  }, [fetchJson, uid, qUser]);

  useEffect(() => {
    if (!uid) return;
    loadSubjects();
    loadEducationLevels();
  }, [uid, loadSubjects, loadEducationLevels]);

  const searchBoclips = useCallback(
    async (pageOverride = null) => {
      if (!uid) {
        setError('User not logged in');
        return;
      }
      searchAbortRef.current?.abort();
      const ac = new AbortController();
      searchAbortRef.current = ac;
      const seq = ++searchSeqRef.current;

      const page = pageOverride != null ? pageOverride : searchPageRef.current;
      setVideosLoading(true);
      setError(null);
      const p = searchParamsRef.current;
      try {
        const params = new URLSearchParams();
        params.set('userId', uid);
        const q = p.searchQuery.trim() || 'education';
        params.set('query', q);
        params.set('limit', '20');
        params.set('page', String(page));

        p.selectedSubjectIds.forEach((id) => params.append('subject', id));
        if (p.channelFilterId) params.append('channel', p.channelFilterId);
        p.selectedEduLevels.forEach((code) => params.append('education_level', code));
        p.selectedCefr.forEach((c) => params.append('cefr_level', c));
        p.bestForLabels.forEach((b) => params.append('best_for', b.toLowerCase()));
        if (p.sortBy) params.set('sort_by', p.sortBy);
        if (p.durationMinSec > 0) params.set('duration_min', secondsToIsoDuration(p.durationMinSec));
        if (p.durationMaxSec < 7200) params.set('duration_max', secondsToIsoDuration(p.durationMaxSec));

        const data = await fetchJson(`/providers/boclips/search?${params.toString()}`, { signal: ac.signal });
        if (seq !== searchSeqRef.current) return;
        setVideos(extractVideos(data));
      } catch (err) {
        if (err?.name === 'AbortError') return;
        if (seq !== searchSeqRef.current) return;
        setError(err.message || 'Search failed');
        setVideos([]);
      } finally {
        if (seq === searchSeqRef.current) {
          setVideosLoading(false);
        }
      }
    },
    [uid, fetchJson],
  );

  useEffect(() => {
    if (!uid || activeTab !== 'videos') return;
    if (isInitialMount.current) {
      isInitialMount.current = false;
      searchBoclips(0);
      return;
    }
    searchBoclips();
  }, [uid, activeTab, searchPage, debouncedFilterSignature, searchBoclips]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSearchPage(0);
    if (currentUser) searchBoclips(0);
  };

  const loadCollectionsTab = useCallback(async () => {
    if (!uid) return;
    const seq = ++collectionsSeqRef.current;
    setCollectionsLoading(true);
    try {
      const [d, m] = await Promise.all([
        fetchJson(`/providers/boclips/collections?${qUser}&scope=discover&size=30`),
        fetchJson(`/providers/boclips/collections?${qUser}&scope=mine&size=30`),
      ]);
      if (seq !== collectionsSeqRef.current) return;
      setDiscoverCollections(extractCollections(d));
      setMyCollections(extractCollections(m));
    } catch (e) {
      if (seq !== collectionsSeqRef.current) return;
      setError(e.message);
    } finally {
      if (seq === collectionsSeqRef.current) setCollectionsLoading(false);
    }
  }, [fetchJson, uid, qUser]);

  useEffect(() => {
    if (activeTab === 'collections' && uid) loadCollectionsTab();
  }, [activeTab, uid, loadCollectionsTab]);

  const loadPlaylists = useCallback(async () => {
    if (!uid) return;
    const seq = ++playlistsSeqRef.current;
    setPlaylistsLoading(true);
    try {
      const data = await fetchJson(`/playlists?${qUser}`);
      if (seq !== playlistsSeqRef.current) return;
      setMyPlaylists(data?.playlists || []);
    } catch (e) {
      if (seq !== playlistsSeqRef.current) return;
      setError(e.message);
      setMyPlaylists([]);
    } finally {
      if (seq === playlistsSeqRef.current) setPlaylistsLoading(false);
    }
  }, [fetchJson, uid, qUser]);

  useEffect(() => {
    if (activeTab === 'playlists' && uid) loadPlaylists();
  }, [activeTab, uid, loadPlaylists]);

  useEffect(() => {
    if (uid && selectedVideo && videoToken) loadPlaylists();
  }, [uid, selectedVideo, videoToken, loadPlaylists]);

  const openPlaylistDetail = async (playlistId) => {
    if (!uid) return;
    const meta = myPlaylists.find((p) => p.id === playlistId);
    setPlaylistDetailModal({
      id: playlistId,
      title: meta?.title || 'Playlist',
    });
    setPlaylistVideosLoading(true);
    setPlaylistVideos([]);
    try {
      const data = await fetchJson(`/playlists/${encodeURIComponent(playlistId)}/videos?${qUser}`);
      setPlaylistVideos(data?.videos || []);
    } catch (e) {
      setError(e.message);
    } finally {
      setPlaylistVideosLoading(false);
    }
  };

  const refreshPlaylistVideos = async (playlistId) => {
    if (!uid) return;
    try {
      const data = await fetchJson(`/playlists/${encodeURIComponent(playlistId)}/videos?${qUser}`);
      setPlaylistVideos(data?.videos || []);
    } catch {
      /* keep list as-is */
    }
  };

  const closePlaylistDetail = () => {
    setPlaylistDetailModal(null);
    setPlaylistVideos([]);
  };

  const openPlCreateModal = () => {
    setPlFormMode('create');
    setPlEditingId(null);
    setPlFormTitle('');
    setPlFormDesc('');
    setPlModalOpen(true);
  };

  const openPlEditModal = (p) => {
    setPlFormMode('edit');
    setPlEditingId(p.id);
    setPlFormTitle(p.title || '');
    setPlFormDesc(p.description || '');
    setPlModalOpen(true);
  };

  const submitPlaylistForm = async (e) => {
    e.preventDefault();
    if (!uid || !plFormTitle.trim()) return;
    try {
      if (plFormMode === 'create') {
        await fetchJson('/playlists', {
          method: 'POST',
          body: JSON.stringify({
            userId: uid,
            title: plFormTitle.trim(),
            description: plFormDesc.trim() || undefined,
          }),
        });
      } else if (plEditingId) {
        await fetchJson(`/playlists/${encodeURIComponent(plEditingId)}`, {
          method: 'PATCH',
          body: JSON.stringify({
            userId: uid,
            title: plFormTitle.trim(),
            description: plFormDesc.trim() || null,
          }),
        });
      }
      setPlModalOpen(false);
      loadPlaylists();
      if (playlistDetailModal?.id === plEditingId) {
        setPlaylistDetailModal((prev) =>
          prev ? { ...prev, title: plFormTitle.trim() } : prev,
        );
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const deletePlaylistById = async (playlistId) => {
    if (!uid) return;
    if (!window.confirm('Delete this playlist and all saved videos in it?')) return;
    try {
      const res = await fetch(`${apiBase}/playlists/${encodeURIComponent(playlistId)}?${qUser}`, {
        method: 'DELETE',
        headers: authHeaders,
      });
      if (!res.ok) throw new Error('Delete failed');
      if (playlistDetailModal?.id === playlistId) closePlaylistDetail();
      loadPlaylists();
    } catch {
      setError('Could not delete playlist');
    }
  };

  const removeVideoFromPlaylist = async (playlistId, videoId) => {
    if (!uid) return;
    try {
      const res = await fetch(
        `${apiBase}/playlists/${encodeURIComponent(playlistId)}/videos/${encodeURIComponent(videoId)}?${qUser}`,
        { method: 'DELETE', headers: authHeaders },
      );
      if (!res.ok) throw new Error('Remove failed');
      await refreshPlaylistVideos(playlistId);
      loadPlaylists();
    } catch {
      setError('Could not remove video from playlist');
    }
  };

  const addVideoToPlaylist = async () => {
    if (!uid || !selectedVideo || !addToPlaylistId) return;
    const vid = selectedVideo.id || selectedVideo.videoId;
    const thumb = getVideoThumbnail(selectedVideo);
    const dur = getVideoDuration(selectedVideo);
    const pid = addToPlaylistId;
    try {
      await fetchJson(`/playlists/${encodeURIComponent(pid)}/videos/${encodeURIComponent(vid)}`, {
        method: 'PUT',
        body: JSON.stringify({
          userId: uid,
          title: selectedVideo.title || null,
          thumbnail: thumb,
          duration: dur,
        }),
      });
      setAddToPlaylistId('');
      loadPlaylists();
      if (playlistDetailModal?.id === pid) await refreshPlaylistVideos(pid);
    } catch {
      setError('Could not add to playlist');
    }
  };

  const loadChannels = useCallback(async () => {
    if (!uid) return;
    const seq = ++channelsSeqRef.current;
    setChannelsLoading(true);
    try {
      const data = await fetchJson(
        `/providers/boclips/channels?${qUser}&page=${channelsPage}&size=48&projection=list`,
      );
      if (seq !== channelsSeqRef.current) return;
      setChannels(extractChannels(data));
    } catch (e) {
      if (seq !== channelsSeqRef.current) return;
      setError(e.message);
    } finally {
      if (seq === channelsSeqRef.current) setChannelsLoading(false);
    }
  }, [fetchJson, uid, qUser, channelsPage]);

  useEffect(() => {
    if (activeTab === 'channels' && uid) loadChannels();
  }, [activeTab, uid, channelsPage, loadChannels]);

  const searchHighlights = async (e) => {
    e?.preventDefault();
    if (!uid) return;
    const seq = ++highlightsSeqRef.current;
    setHighlightsLoading(true);
    setError(null);
    try {
      const q = highlightsQuery.trim() || 'science';
      const data = await fetchJson(
        `/providers/boclips/highlights?${qUser}&query=${encodeURIComponent(q)}&size=24`,
      );
      if (seq !== highlightsSeqRef.current) return;
      setHighlights(extractHighlights(data));
    } catch (err) {
      if (seq !== highlightsSeqRef.current) return;
      setError(err.message);
      setHighlights([]);
    } finally {
      if (seq === highlightsSeqRef.current) setHighlightsLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'highlights' && uid && highlights.length === 0 && !highlightsLoading) {
      searchHighlights();
    }
  }, [activeTab, uid]); // eslint-disable-line react-hooks/exhaustive-deps

  const openCollection = async (id) => {
    if (!uid) return;
    setCollectionDetailLoading(true);
    setCollectionDetail(null);
    try {
      const data = await fetchJson(
        `/providers/boclips/collections/${encodeURIComponent(id)}?${qUser}&projection=full`,
      );
      setCollectionDetail(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setCollectionDetailLoading(false);
    }
  };

  const createCollection = async (e) => {
    e.preventDefault();
    if (!uid || !newTitle.trim()) return;
    try {
      await fetchJson('/providers/boclips/collections', {
        method: 'POST',
        body: JSON.stringify({
          userId: uid,
          title: newTitle.trim(),
          description: newDesc.trim() || undefined,
          videos: [],
          subjects: [],
          discoverable: false,
        }),
      });
      setCreateOpen(false);
      setNewTitle('');
      setNewDesc('');
      loadCollectionsTab();
    } catch (err) {
      setError(err.message);
    }
  };

  const removeVideoFromCollection = async (collectionId, videoId) => {
    if (!uid) return;
    try {
      const res = await fetch(
        `${apiBase}/providers/boclips/collections/${encodeURIComponent(collectionId)}/videos/${encodeURIComponent(videoId)}?${qUser}`,
        { method: 'DELETE', headers: authHeaders },
      );
      if (!res.ok) throw new Error('Remove failed');
      openCollection(collectionId);
      loadCollectionsTab();
    } catch {
      setError('Could not remove video');
    }
  };



  const getVideoToken = async () => {
    const res = await fetch(`${apiBase}/providers/boclips/token?${qUser}`, { headers: authHeaders });
    if (!res.ok) throw new Error('Token failed');
    const data = await res.json();
    return data.token;
  };

  const sendPlaybackSegment = async (videoId, startSec, endSec) => {
    if (!uid || endSec <= startSec) return;
    try {
      await fetch(`${apiBase}/providers/boclips/events/playback`, {
        method: 'POST',
        headers: authHeaders,
        body: JSON.stringify({
          userId: uid,
          videoId,
          segmentStartSeconds: startSec,
          segmentEndSeconds: endSec,
          boclipsUserId: uid,
        }),
      });
    } catch {
      /* non-fatal */
    }
  };

  const handleVideoClick = async (video) => {
    if (!currentUser) {
      setError('Please log in to watch videos');
      return;
    }
    try {
      setVideoOpenLoading(true);
      const token = await getVideoToken();
      setVideoToken(token);
      setSelectedVideo(video);
      setModalTab('watch');
      setLearningOutcomes(null);
      setAssessmentQs(null);
      setTranscript(null);
    } catch (err) {
      setError(err.message || 'Failed to open video');
    } finally {
      setVideoOpenLoading(false);
    }
  };

  const playSavedPlaylistVideo = async (row) => {
    if (!row?.video_id) return;
    try {
      const full = await fetchJson(`/providers/boclips/videos/${encodeURIComponent(row.video_id)}?${qUser}`);
      await handleVideoClick(full);
    } catch {
      await handleVideoClick({
        id: row.video_id,
        videoId: row.video_id,
        title: row.title || 'Video',
      });
    }
  };

  const handleCloseVideo = () => {
    if (hlsRef.current) {
      hlsRef.current.destroy();
      hlsRef.current = null;
    }
    playbackSegmentStart.current = null;
    setSelectedVideo(null);
    setVideoToken(null);
    setModalTab('watch');
    setLearningOutcomes(null);
    setAssessmentQs(null);
    setTranscript(null);

    setAddToPlaylistId('');
  };

  useEffect(() => {
    if (selectedVideo && videoToken && videoRef.current) {
      const streamUrl = getVideoStreamUrl(selectedVideo);
      if (!streamUrl) return;

      if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
        videoRef.current.src = streamUrl;
      } else if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(streamUrl);
        hls.attachMedia(videoRef.current);
        hlsRef.current = hls;
        hls.on(Hls.Events.ERROR, (_event, data) => {
          if (data.fatal) {
            if (data.type === Hls.ErrorTypes.NETWORK_ERROR) hls.startLoad();
            else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) hls.recoverMediaError();
            else hls.destroy();
          }
        });
      } else {
        videoRef.current.src = streamUrl;
      }
    }
    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
    };
  }, [selectedVideo, videoToken]);

  const onVideoPlay = () => {
    const el = videoRef.current;
    if (el) playbackSegmentStart.current = el.currentTime;
  };

  const onVideoPauseOrEnded = () => {
    const el = videoRef.current;
    const vid = selectedVideo?.id || selectedVideo?.videoId;
    if (!el || playbackSegmentStart.current == null || !vid) return;
    const end = el.currentTime;
    const start = playbackSegmentStart.current;
    if (end > start + 0.5) {
      sendPlaybackSegment(vid, start, end);
    }
    playbackSegmentStart.current = el.ended ? null : el.currentTime;
  };

  useEffect(() => {
    if (!selectedVideo || !videoToken || !uid) return;
    const loadTab = async () => {
      const vid = selectedVideo.id || selectedVideo.videoId;
      if (!vid) return;
      if (modalTab === 'learning') {
        if (learningOutcomes != null) return;
        setModalExtraLoading(true);
        try {
          const d = await fetchJson(
            `/providers/boclips/videos/${encodeURIComponent(vid)}/learning-outcomes?${qUser}`,
          );
          setLearningOutcomes(d);
        } catch {
          setLearningOutcomes({ error: true });
        } finally {
          setModalExtraLoading(false);
        }
      }
      if (modalTab === 'assessment') {
        if (assessmentQs != null) return;
        setModalExtraLoading(true);
        try {
          const d = await fetchJson(
            `/providers/boclips/videos/${encodeURIComponent(vid)}/assessment-questions?${qUser}`,
          );
          setAssessmentQs(d);
        } catch {
          setAssessmentQs({ error: true });
        } finally {
          setModalExtraLoading(false);
        }
      }
      if (modalTab === 'transcript') {
        if (transcript != null) return;
        setModalExtraLoading(true);
        try {
          const d = await fetchJson(
            `/providers/boclips/videos/${encodeURIComponent(vid)}/transcript?${qUser}`,
          );
          setTranscript(d);
        } catch {
          setTranscript({ error: true });
        } finally {
          setModalExtraLoading(false);
        }
      }
    };
    loadTab();
  }, [modalTab, selectedVideo, videoToken, uid, fetchJson, qUser]); // eslint-disable-line react-hooks/exhaustive-deps

  const filteredSubjects = useMemo(() => {
    if (!subjectSearch.trim()) return subjects;
    const q = subjectSearch.toLowerCase();
    return subjects.filter((s) => (s.name || '').toLowerCase().includes(q));
  }, [subjects, subjectSearch]);

  const toggleSubject = (id) => {
    setSelectedSubjectIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const toggleEduLevel = (code) => {
    setSelectedEduLevels((prev) =>
      prev.includes(code) ? prev.filter((x) => x !== code) : [...prev, code],
    );
  };

  const toggleCefr = (c) => {
    setSelectedCefr((prev) => (prev.includes(c) ? prev.filter((x) => x !== c) : [...prev, c]));
  };

  const toggleBestFor = (label) => {
    setBestForLabels((prev) => (prev.includes(label) ? prev.filter((x) => x !== label) : [...prev, label]));
  };

  const clearFilters = () => {
    setSelectedSubjectIds([]);
    setSelectedEduLevels([]);
    setSelectedCefr([]);
    setBestForLabels([]);
    setSortBy('');
    setDurationMinSec(0);
    setDurationMaxSec(3600);
    setChannelFilterId(null);
    setChannelFilterName('');
  };

  const activeFilterCount =
    selectedSubjectIds.length +
    selectedEduLevels.length +
    selectedCefr.length +
    bestForLabels.length +
    (channelFilterId ? 1 : 0) +
    (sortBy ? 1 : 0) +
    (durationMinSec > 0 || durationMaxSec < 3600 ? 1 : 0);

  const onSearchInputChange = (v) => {
    setSearchQuery(v);
    if (suggestionTimer.current) clearTimeout(suggestionTimer.current);
    if (!v.trim() || !uid) {
      setSuggestions([]);
      return;
    }
    suggestionTimer.current = setTimeout(async () => {
      try {
        const data = await fetchJson(
          `/providers/boclips/suggestions?${qUser}&query=${encodeURIComponent(v)}`,
        );
        const list = Array.isArray(data) ? data : data?.suggestions || data?._embedded?.suggestions || [];
        setSuggestions(Array.isArray(list) ? list.slice(0, 8) : []);
      } catch {
        setSuggestions([]);
      }
    }, 280);
  };

  const handleCopyLink = (e, video) => {
    e.stopPropagation();
    const videoId = video.id || video.videoId;
    if (videoId) {
      navigator.clipboard?.writeText(`${window.location.origin}/providers/boclips#${videoId}`);
    }
  };

  const openHighlightAsVideo = async (h) => {
    const vid = h.video_id || h.videoId;
    if (!vid) return;
    try {
      const full = await fetchJson(`/providers/boclips/videos/${encodeURIComponent(vid)}?${qUser}`);
      await handleVideoClick(full);
    } catch {
      setError('Could not load video for this highlight');
    }
  };

  const renderVideoCard = (video) => {
    const thumbnail = getVideoThumbnail(video);
    const duration = getVideoDuration(video);
    const videoId = video.id || video.videoId || Math.random().toString();
    const creator = video.createdBy || video.channelName || video.channel?.name || '';
    const date = formatDate(video.releasedOn || video.publishedAt || video.createdAt);
    const subjList = (video.subjects || []).map((s) => (typeof s === 'string' ? s : s.name)).filter(Boolean);
    const minAge = video.ageRange?.min;
    const maxAge = video.ageRange?.max;
    const ageRange =
      minAge != null && maxAge != null
        ? `Ages ${minAge}-${maxAge}`
        : minAge != null
          ? `Ages ${minAge}+`
          : maxAge != null
            ? `Up to age ${maxAge}`
            : null;

    return (
      <article
        key={videoId}
        className="bc-card"
        onClick={() => handleVideoClick(video)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && handleVideoClick(video)}
      >
        <div className="bc-card-thumb">
          {thumbnail ? (
            <img
              src={thumbnail}
              alt={video.title || 'Video'}
              className="bc-card-thumb-img"
              onError={(e) => { e.target.style.display = 'none'; }}
              loading="lazy"
            />
          ) : null}
          <div className="bc-card-thumb-overlay">
            <PlayIcon />
          </div>
          {duration && <span className="bc-card-duration">{duration}</span>}
        </div>
        <div className="bc-card-body">
          <h3 className="bc-card-title">{video.title || 'Untitled'}</h3>
          <div className="bc-card-meta">
            {date && <span className="bc-card-date">{date}</span>}
            {date && creator && <span className="bc-card-sep">&middot;</span>}
            {creator && <span className="bc-card-creator">{creator}</span>}
          </div>
          {(subjList.length > 0 || ageRange) && (
            <div className="bc-card-tags">
              {subjList.slice(0, 3).map((s) => (
                <span key={s} className="bc-tag">{s}</span>
              ))}
              {ageRange && <span className="bc-tag bc-tag--age">{ageRange}</span>}
            </div>
          )}
          {viewMode === 'list' && video.description && (
            <p className="bc-card-desc">
              {video.description.length > 220 ? `${video.description.substring(0, 220)}…` : video.description}
            </p>
          )}
          {viewMode === 'list' && (
            <div className="bc-card-actions">
              <button type="button" className="bc-action-btn" onClick={(e) => e.stopPropagation()} title="Share">
                <ShareIcon /> Share
              </button>
              <button type="button" className="bc-action-btn" onClick={(e) => handleCopyLink(e, video)} title="Copy link">
                <LinkIcon /> Copy link
              </button>
            </div>
          )}
        </div>
      </article>
    );
  };

  const videoListBusy = videosLoading || filtersPendingSync;
  const videoGridOverlay = videos.length > 0 && videoListBusy;

  return (
    <div className="bc-page">
      <div className="bc-search-section">
        <div className="bc-search-row">
          {activeTab === 'videos' && (
            <form onSubmit={handleSearchSubmit} className="bc-search-form">
              <div className="bc-search-input-wrap bc-search-input-wrap--suggest">
                <span className="bc-search-icon"><SearchIcon /></span>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => onSearchInputChange(e.target.value)}
                  onFocus={() => setShowSuggestions(true)}
                  onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                  placeholder="Search for videos…"
                  className="bc-search-input"
                  autoComplete="off"
                />
                {showSuggestions && suggestions.length > 0 && (
                  <ul className="bc-suggestions">
                    {suggestions.map((s, i) => (
                      <li key={i}>
                        <button
                          type="button"
                          className="bc-suggestion-item"
                          onMouseDown={() => {
                            const text = typeof s === 'string' ? s : s.text || s.label || s.query || '';
                            setSearchQuery(text);
                            setShowSuggestions(false);
                          }}
                        >
                          {typeof s === 'string' ? s : s.text || s.label || s.query || JSON.stringify(s)}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <button type="submit" className="bc-search-btn" disabled={videosLoading || videoOpenLoading}>
                {videosLoading ? 'Searching…' : 'Search'}
              </button>
            </form>
          )}
          {activeTab === 'highlights' && (
            <form onSubmit={searchHighlights} className="bc-search-form">
              <div className="bc-search-input-wrap">
                <span className="bc-search-icon"><SearchIcon /></span>
                <input
                  type="text"
                  value={highlightsQuery}
                  onChange={(e) => setHighlightsQuery(e.target.value)}
                  placeholder="Semantic search for clips…"
                  className="bc-search-input"
                />
              </div>
              <button type="submit" className="bc-search-btn" disabled={highlightsLoading}>
                {highlightsLoading ? 'Searching…' : 'Search'}
              </button>
            </form>
          )}
          {activeTab !== 'videos' && activeTab !== 'highlights' && <div className="bc-search-form bc-search-form--spacer" />}
          <div className="bc-search-logos">
            <img src={boclipsLogo} alt="Boclips" className="bc-search-logo bc-search-logo--boclips" />
            <span className="bc-search-logo-divider" />
            <img src={mdsLogo} alt="MyDigitalSchool" className="bc-search-logo bc-search-logo--mds" />
          </div>
        </div>
      </div>

      <div className="bc-tabs-bar">
        <div className="bc-tabs-inner">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`bc-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => {
                setActiveTab(tab.id);
                setMobileSidebarOpen(false);
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {channelFilterId && activeTab === 'videos' && (
        <div className="bc-chips-bar">
          <div className="bc-chips-inner">
            <span className="bc-chip bc-chip--channel">
              Channel: {channelFilterName || channelFilterId}
              <button type="button" className="bc-chip-x" onClick={() => { setChannelFilterId(null); setChannelFilterName(''); }} aria-label="Clear channel">
                <CloseIcon size={10} />
              </button>
            </span>
          </div>
        </div>
      )}

      <div className="bc-layout">
        {activeTab === 'videos' && (
          <>
            <button type="button" className="bc-sidebar-toggle" onClick={() => setMobileSidebarOpen(!mobileSidebarOpen)}>
              <FilterIcon />
              <span>Filters</span>
              {activeFilterCount > 0 && <span className="bc-filter-badge">{activeFilterCount}</span>}
            </button>
            <aside className={`bc-sidebar ${mobileSidebarOpen ? 'bc-sidebar--open' : ''}`}>
              <div className="bc-sidebar-head">
                <h3 className="bc-sidebar-title">Filters</h3>
                <button type="button" className="bc-sidebar-close-mobile" onClick={() => setMobileSidebarOpen(false)} aria-label="Close filters">
                  <CloseIcon size={16} />
                </button>
              </div>

              <div className="bc-filter-section">
                <h4 className="bc-filter-heading">Sort</h4>
                <div className="bc-select-wrap">
                  <select className="bc-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)} aria-label="Sort results">
                    {SORT_OPTIONS.map((o) => (
                      <option key={o.value || 'rel'} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="bc-filter-section">
                <h4 className="bc-filter-heading">Duration (approx.)</h4>
                <div className="bc-range-row">
                  <label className="bc-range-label">
                    Min {formatDuration(durationMinSec)}
                    <input
                      type="range"
                      min={0}
                      max={1800}
                      step={30}
                      value={durationMinSec}
                      onChange={(e) => setDurationMinSec(Number(e.target.value))}
                      className="bc-range"
                    />
                  </label>
                  <label className="bc-range-label">
                    Max {formatDuration(durationMaxSec)}
                    <input
                      type="range"
                      min={60}
                      max={7200}
                      step={60}
                      value={durationMaxSec}
                      onChange={(e) => setDurationMaxSec(Number(e.target.value))}
                      className="bc-range"
                    />
                  </label>
                </div>
              </div>

              <div className="bc-filter-section">
                <h4 className="bc-filter-heading">Subjects {subjectsLoading && <span className="bc-muted">(loading…)</span>}</h4>
                <div className="bc-subject-search-wrap">
                  <span className="bc-subject-search-icon"><SearchIcon /></span>
                  <input
                    type="text"
                    placeholder="Filter subject list"
                    className="bc-subject-search"
                    value={subjectSearch}
                    onChange={(e) => setSubjectSearch(e.target.value)}
                  />
                </div>
                <div className="bc-subject-list bc-subject-list--flat">
                  {filteredSubjects.map((s) => {
                    const checked = selectedSubjectIds.includes(s.id);
                    return (
                      <label key={s.id} className={`bc-check-item ${checked ? 'bc-check-item--active' : ''}`}>
                        <input type="checkbox" checked={checked} onChange={() => toggleSubject(s.id)} className="bc-check-input" />
                        <span className="bc-check-box" />
                        <span className="bc-check-label">{s.name}</span>
                      </label>
                    );
                  })}
                </div>
              </div>

              <div className="bc-filter-section">
                <h4 className="bc-filter-heading">Education level</h4>
                <div className="bc-bestfor-list">
                  {educationLevels.map((el) => {
                    const code = el.code || el.id;
                    const label = el.label || el.name || code;
                    const checked = selectedEduLevels.includes(code);
                    return (
                      <label key={code} className={`bc-check-item ${checked ? 'bc-check-item--active' : ''}`}>
                        <input type="checkbox" checked={checked} onChange={() => toggleEduLevel(code)} className="bc-check-input" />
                        <span className="bc-check-box" />
                        <span className="bc-check-label">{label}</span>
                      </label>
                    );
                  })}
                </div>
              </div>

              <div className="bc-filter-section">
                <h4 className="bc-filter-heading">CEFR</h4>
                <div className="bc-cefr-row">
                  {CEFR_LEVELS.map((c) => {
                    const checked = selectedCefr.includes(c);
                    return (
                      <button
                        key={c}
                        type="button"
                        className={`bc-cefr-btn ${checked ? 'bc-cefr-btn--on' : ''}`}
                        onClick={() => toggleCefr(c)}
                      >
                        {c}
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="bc-filter-section">
                <h4 className="bc-filter-heading">Best for</h4>
                <div className="bc-bestfor-list">
                  {BEST_FOR_OPTIONS.map((option) => {
                    const checked = bestForLabels.includes(option.label);
                    return (
                      <label key={option.id} className={`bc-check-item ${checked ? 'bc-check-item--active' : ''}`}>
                        <input type="checkbox" checked={checked} onChange={() => toggleBestFor(option.label)} className="bc-check-input" />
                        <span className="bc-check-box" />
                        <span className="bc-check-label">{option.label}</span>
                      </label>
                    );
                  })}
                </div>
              </div>

              <button type="button" className="bc-clear-filters-btn" onClick={clearFilters}>
                Clear all filters
              </button>
            </aside>
          </>
        )}

        <main className={`bc-content ${activeTab !== 'videos' ? 'bc-content--full' : ''}`}>
          {activeTab === 'videos' && (
            <>
              <div className="bc-toolbar">
                <div className="bc-view-toggle">
                  <button type="button" className={`bc-view-btn ${viewMode === 'list' ? 'bc-view-btn--active' : ''}`} onClick={() => setViewMode('list')} title="List view">
                    <ListIcon />
                  </button>
                  <button type="button" className={`bc-view-btn ${viewMode === 'grid' ? 'bc-view-btn--active' : ''}`} onClick={() => setViewMode('grid')} title="Grid view">
                    <GridIcon />
                  </button>
                </div>
                <div className="bc-toolbar-right">
                  <button type="button" className="bc-page-btn" disabled={searchPage <= 0 || videoListBusy} onClick={() => setSearchPage((p) => Math.max(0, p - 1))}>
                    Previous
                  </button>
                  <span className="bc-page-label">Page {searchPage + 1}</span>
                  <button type="button" className="bc-page-btn" disabled={videos.length < 20 || videoListBusy} onClick={() => setSearchPage((p) => p + 1)}>
                    Next
                  </button>
                </div>
              </div>
              {error && <div className="bc-error"><p>{error}</p></div>}
              {videos.length === 0 && videosLoading && (
                <div className="bc-loading">
                  <div className="bc-spinner" />
                  <p>Loading…</p>
                </div>
              )}
              {videos.length === 0 && !videosLoading && filtersPendingSync && (
                <div className="bc-loading bc-loading--compact">
                  <div className="bc-spinner" />
                  <p>Applying filters…</p>
                </div>
              )}
              {(videos.length > 0 || videoGridOverlay) && (
                <div className={`bc-results-surface${videoGridOverlay ? ' bc-results-surface--busy' : ''}`}>
                  {videoGridOverlay && (
                    <div className="bc-results-overlay" aria-live="polite" aria-busy="true">
                      <div className="bc-spinner bc-spinner--overlay" />
                      <span className="bc-results-overlay-text">
                        {filtersPendingSync && !videosLoading ? 'Applying filters…' : 'Updating results…'}
                      </span>
                    </div>
                  )}
                  {videos.length > 0 && (
                    <div className={`bc-videos bc-videos--${viewMode}${videoGridOverlay ? ' bc-videos--muted' : ''}`}>
                      {videos.map((v) => renderVideoCard(v))}
                    </div>
                  )}
                </div>
              )}
              {!videoListBusy && !error && videos.length === 0 && (
                <div className="bc-empty">
                  <h3>No videos found</h3>
                  <p>Try different keywords or filters.</p>
                </div>
              )}
            </>
          )}

          {activeTab === 'playlists' && (
            <div className="bc-panel">
              <div className="bc-panel-head">
                <h2 className="bc-panel-title">My playlists</h2>
                <button type="button" className="bc-primary-btn bc-primary-btn--icon" onClick={openPlCreateModal}>
                  <PlusIcon /> New playlist
                </button>
              </div>
              <p className="bc-panel-intro">Your saved Boclips videos — stored in My Digital Schools (not in Boclips collections).</p>
              <div className={`bc-tab-body${playlistsLoading ? ' bc-tab-body--busy' : ''}`}>
                {playlistsLoading && (
                  <div className="bc-tab-overlay" aria-live="polite" aria-busy="true">
                    <div className="bc-spinner bc-spinner--overlay" />
                    <span>Loading playlists…</span>
                  </div>
                )}
                <div className="bc-playlist-grid">
                  {myPlaylists.map((p) => (
                    <article key={p.id} className="bc-playlist-card">
                      <button type="button" className="bc-playlist-card-body" onClick={() => openPlaylistDetail(p.id)}>
                        <div className="bc-playlist-icon-wrap">
                          <FolderIcon />
                        </div>
                        <div className="bc-playlist-info-wrap">
                          <div className="bc-playlist-card-title">{p.title || 'Untitled'}</div>
                          {p.description ? <p className="bc-playlist-card-desc">{p.description}</p> : null}
                          <span className="bc-playlist-meta">
                            {typeof p.videoCount === 'number' ? `${p.videoCount} video${p.videoCount === 1 ? '' : 's'}` : '0 videos'}
                          </span>
                        </div>
                      </button>
                      <div className="bc-playlist-card-toolbar">
                        <button type="button" className="bc-link-btn bc-link-btn--edit" onClick={() => openPlEditModal(p)}>
                          <EditIcon /> Edit
                        </button>
                        <button type="button" className="bc-link-btn bc-link-btn--danger" onClick={() => deletePlaylistById(p.id)}>
                          <TrashIcon /> Delete
                        </button>
                      </div>
                    </article>
                  ))}
                </div>
                {!playlistsLoading && myPlaylists.length === 0 && (
                  <div className="bc-empty"><p>No playlists yet — create one and add videos from the player.</p></div>
                )}
              </div>
              {playlistDetailModal && (
                <div className="bc-modal-overlay" role="dialog" aria-modal="true" onClick={closePlaylistDetail}>
                  <div className="bc-modal bc-modal--wide" onClick={(e) => e.stopPropagation()}>
                    <div className="bc-modal-header">
                      <h2 className="bc-modal-title">{playlistDetailModal.title}</h2>
                      <button type="button" className="bc-modal-close" onClick={closePlaylistDetail} aria-label="Close">&times;</button>
                    </div>
                    <div className="bc-modal-body">
                      {playlistVideosLoading && <p className="bc-muted">Loading…</p>}
                      {!playlistVideosLoading && playlistVideos.length === 0 && (
                        <p className="bc-muted">No videos in this playlist yet.</p>
                      )}
                      {!playlistVideosLoading && playlistVideos.length > 0 && (
                        <ul className="bc-playlist-video-list">
                          {playlistVideos.map((row) => (
                            <li key={row.id} className="bc-playlist-video-row">
                              {row.thumbnail ? (
                                <img src={row.thumbnail} alt="" className="bc-playlist-video-thumb" />
                              ) : (
                                <div className="bc-playlist-video-thumb bc-playlist-video-thumb--empty" />
                              )}
                              <div className="bc-playlist-video-info">
                                <span className="bc-playlist-video-title">{row.title || row.video_id}</span>
                                {row.duration && <span className="bc-playlist-video-dur">{row.duration}</span>}
                              </div>
                              <div className="bc-playlist-video-actions">
                                <button type="button" className="bc-secondary-btn" onClick={() => playSavedPlaylistVideo(row)}>Play</button>
                                <button
                                  type="button"
                                  className="bc-link-btn"
                                  onClick={() => removeVideoFromPlaylist(playlistDetailModal.id, row.video_id)}
                                >
                                  Remove
                                </button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === 'collections' && (
            <div className="bc-panel">
              <div className="bc-panel-head">
                <h2>Collections</h2>
                <button type="button" className="bc-primary-btn" onClick={() => setCreateOpen(true)}>New collection</button>
              </div>
              <div className={`bc-tab-body${collectionsLoading ? ' bc-tab-body--busy' : ''}`}>
                {collectionsLoading && (
                  <div className="bc-tab-overlay" aria-live="polite" aria-busy="true">
                    <div className="bc-spinner bc-spinner--overlay" />
                    <span>Loading collections…</span>
                  </div>
                )}
                <section className="bc-section">
                  <h3 className="bc-section-title">Discover</h3>
                  <div className="bc-collection-grid">
                    {discoverCollections.map((c) => (
                      <button type="button" key={c.id} className="bc-collection-card" onClick={() => openCollection(c.id)}>
                        <div className="bc-collection-card-title">{c.title || 'Untitled'}</div>
                        <p className="bc-collection-card-desc">{c.description || ''}</p>
                        <span className="bc-collection-meta">{Array.isArray(c.videos) ? `${c.videos.length} videos` : ''}</span>
                      </button>
                    ))}
                  </div>
                </section>
                <section className="bc-section">
                  <h3 className="bc-section-title">My collections</h3>
                  <div className="bc-collection-grid">
                    {myCollections.map((c) => (
                      <button type="button" key={c.id} className="bc-collection-card bc-collection-card--mine" onClick={() => openCollection(c.id)}>
                        <div className="bc-collection-card-title">{c.title || 'Untitled'}</div>
                        <p className="bc-collection-card-desc">{c.description || ''}</p>
                      </button>
                    ))}
                  </div>
                </section>
              </div>
              {collectionDetail && (
                <div className="bc-modal-overlay" role="dialog" aria-modal="true" onClick={() => setCollectionDetail(null)}>
                  <div className="bc-modal bc-modal--wide" onClick={(e) => e.stopPropagation()}>
                    <div className="bc-modal-header">
                      <h2 className="bc-modal-title">{collectionDetail.title}</h2>
                      <button type="button" className="bc-modal-close" onClick={() => setCollectionDetail(null)} aria-label="Close">&times;</button>
                    </div>
                    <div className="bc-modal-body">
                      {collectionDetailLoading && <p>Loading…</p>}
                      {!collectionDetailLoading && (
                        <div className={`bc-videos bc-videos--${viewMode}`}>
                          {(collectionDetail.videos || []).map((v) => renderVideoCard(v))}
                        </div>
                      )}
                      {!collectionDetailLoading && myCollections.some((m) => m.id === collectionDetail.id) && (
                        <ul className="bc-collection-video-list">
                          {(collectionDetail.videos || []).map((v) => {
                            const id = v.id || v.videoId;
                            return (
                              <li key={id}>
                                <span>{v.title}</span>
                                <button type="button" className="bc-link-btn" onClick={() => removeVideoFromCollection(collectionDetail.id, id)}>Remove</button>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === 'channels' && (
            <div className="bc-panel">
              <h2 className="bc-panel-title">Channels</h2>
              <div className={`bc-tab-body${channelsLoading ? ' bc-tab-body--busy' : ''}`}>
                {channelsLoading && (
                  <div className="bc-tab-overlay" aria-live="polite" aria-busy="true">
                    <div className="bc-spinner bc-spinner--overlay" />
                    <span>Loading channels…</span>
                  </div>
                )}
                <div className="bc-channel-grid">
                  {channels.map((ch) => (
                    <button
                      type="button"
                      key={ch.id}
                      className="bc-channel-card"
                      onClick={() => {
                        setChannelFilterId(ch.id);
                        setChannelFilterName(ch.name || '');
                        setActiveTab('videos');
                        setSearchPage(0);
                      }}
                    >
                      <div className="bc-channel-name">{ch.name}</div>
                      <p className="bc-channel-desc">{ch.description || ch.oneLineDescription || ''}</p>
                    </button>
                  ))}
                </div>
                <div className="bc-channel-pager">
                  <button type="button" className="bc-page-btn" disabled={channelsPage <= 0 || channelsLoading} onClick={() => setChannelsPage((p) => p - 1)}>Previous</button>
                  <button type="button" className="bc-page-btn" disabled={channelsLoading} onClick={() => setChannelsPage((p) => p + 1)}>Next</button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'highlights' && (
            <div className="bc-panel">
              <p className="bc-beta-tag">Beta — semantic clip search</p>
              <div className={`bc-tab-body${highlightsLoading ? ' bc-tab-body--busy' : ''}`}>
                {highlightsLoading && (
                  <div className="bc-tab-overlay" aria-live="polite" aria-busy="true">
                    <div className="bc-spinner bc-spinner--overlay" />
                    <span>Searching highlights…</span>
                  </div>
                )}
                <div className="bc-highlight-grid">
                  {highlights.map((h) => (
                    <button type="button" key={h.id} className="bc-highlight-card" onClick={() => openHighlightAsVideo(h)}>
                      <div className="bc-highlight-title">{h.title}</div>
                      <div className="bc-highlight-time">
                        {formatDuration(h.start_time)} – {formatDuration(h.end_time)}
                      </div>
                      <p className="bc-highlight-caption">
                        {h.caption
                          ? h.caption.length > 200
                            ? `${h.caption.substring(0, 200)}…`
                            : h.caption
                          : ''}
                      </p>
                      <span className="bc-highlight-by">{h.createdBy}</span>
                    </button>
                  ))}
                </div>
                {!highlightsLoading && highlights.length === 0 && (
                  <div className="bc-empty"><p>No highlights — try another search.</p></div>
                )}
              </div>
            </div>
          )}
        </main>
      </div>

      {createOpen && (
        <div className="bc-modal-overlay" onClick={() => setCreateOpen(false)}>
          <div className="bc-modal bc-modal--small" onClick={(e) => e.stopPropagation()}>
            <div className="bc-modal-header">
              <h2 className="bc-modal-title">New collection</h2>
              <button type="button" className="bc-modal-close" onClick={() => setCreateOpen(false)} aria-label="Close">&times;</button>
            </div>
            <div className="bc-modal-body">
              <form onSubmit={createCollection} className="bc-create-form">
                <label className="bc-field">
                  Title
                  <input className="bc-input" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} placeholder="e.g. Science Experiments" required />
                </label>
                <label className="bc-field">
                  Description
                  <textarea className="bc-textarea" value={newDesc} onChange={(e) => setNewDesc(e.target.value)} rows={3} placeholder="What is this collection about?" />
                </label>
                <button type="submit" className="bc-primary-btn">Create collection</button>
              </form>
            </div>
          </div>
        </div>
      )}

      {plModalOpen && (
        <div className="bc-modal-overlay" onClick={() => setPlModalOpen(false)}>
          <div className="bc-modal bc-modal--small" onClick={(e) => e.stopPropagation()}>
            <div className="bc-modal-header">
              <h2 className="bc-modal-title">{plFormMode === 'create' ? 'New playlist' : 'Edit playlist'}</h2>
              <button type="button" className="bc-modal-close" onClick={() => setPlModalOpen(false)} aria-label="Close">&times;</button>
            </div>
            <div className="bc-modal-body">
              <form onSubmit={submitPlaylistForm} className="bc-create-form">
                <label className="bc-field">
                  Title
                  <input className="bc-input" value={plFormTitle} onChange={(e) => setPlFormTitle(e.target.value)} placeholder="e.g. Math Revision" required />
                </label>
                <label className="bc-field">
                  Description
                  <textarea className="bc-textarea" value={plFormDesc} onChange={(e) => setPlFormDesc(e.target.value)} rows={3} placeholder="Add a short description..." />
                </label>
                <button type="submit" className="bc-primary-btn">{plFormMode === 'create' ? 'Create playlist' : 'Save changes'}</button>
              </form>
            </div>
          </div>
        </div>
      )}

      {selectedVideo && videoToken && (
        <div className="bc-modal-overlay" onClick={handleCloseVideo}>
          <div className="bc-modal bc-modal--player" onClick={(e) => e.stopPropagation()}>
            <div className="bc-modal-header">
              <h2 className="bc-modal-title">{selectedVideo.title}</h2>
              <button type="button" className="bc-modal-close" onClick={handleCloseVideo} aria-label="Close">&times;</button>
            </div>
            <div className="bc-modal-tabs">
              {MODAL_TABS.map((t) => (
                <button
                  key={t.id}
                  type="button"
                  className={`bc-modal-tab ${modalTab === t.id ? 'bc-modal-tab--active' : ''}`}
                  onClick={() => setModalTab(t.id)}
                >
                  {t.label}
                </button>
              ))}
            </div>
            <div className="bc-modal-body">
              {modalTab === 'watch' && (
                <>
                  {selectedVideo.description && <p className="bc-modal-desc">{selectedVideo.description}</p>}
                  <div className="bc-save-to-rows">
                    <div className="bc-add-collection-row">
                      <span className="bc-save-label">My playlist</span>
                      <div className="bc-select-wrap bc-select-wrap--inline">
                        <select
                          className="bc-select bc-select--inline"
                          value={addToPlaylistId}
                          onChange={(e) => setAddToPlaylistId(e.target.value)}
                          aria-label="Choose my playlist"
                        >
                          <option value="">Save to my playlist…</option>
                          {myPlaylists.map((p) => (
                            <option key={p.id} value={p.id}>{p.title}</option>
                          ))}
                        </select>
                      </div>
                      <button type="button" className="bc-secondary-btn" disabled={!addToPlaylistId} onClick={addVideoToPlaylist}>Save</button>
                    </div>
                  </div>
                  <video
                    ref={videoRef}
                    className="bc-video-player"
                    controls
                    autoPlay
                    crossOrigin="anonymous"
                    onPlay={onVideoPlay}
                    onPause={onVideoPauseOrEnded}
                    onEnded={onVideoPauseOrEnded}
                  >
                    <track kind="captions" />
                  </video>
                </>
              )}
              {modalTab === 'learning' && (
                <div className="bc-modal-scroll">
                  {modalExtraLoading && <p>Loading…</p>}
                  {!modalExtraLoading && learningOutcomes?.error && <p className="bc-muted">Not available for this video.</p>}
                  {!modalExtraLoading && learningOutcomes?.learningOutcomes && (
                    <ul className="bc-bullet-list">
                      {learningOutcomes.learningOutcomes.map((line, i) => (
                        <li key={i}>{line}</li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
              {modalTab === 'assessment' && (
                <div className="bc-modal-scroll">
                  {modalExtraLoading && <p>Loading…</p>}
                  {!modalExtraLoading && assessmentQs?.error && <p className="bc-muted">Not available for this video.</p>}
                  {!modalExtraLoading &&
                    (assessmentQs?.assessmentQuestions || assessmentQs?.questions) && (
                      <ol className="bc-numbered-list">
                        {(assessmentQs.assessmentQuestions || assessmentQs.questions).map((q, i) => (
                          <li key={i}>{typeof q === 'string' ? q : q.text || JSON.stringify(q)}</li>
                        ))}
                      </ol>
                    )}
                  {!modalExtraLoading && Array.isArray(assessmentQs) && (
                    <ol className="bc-numbered-list">
                      {assessmentQs.map((q, i) => (
                        <li key={i}>{typeof q === 'string' ? q : q.text || JSON.stringify(q)}</li>
                      ))}
                    </ol>
                  )}
                </div>
              )}
              {modalTab === 'transcript' && (
                <div className="bc-modal-scroll bc-transcript">
                  {modalExtraLoading && <p>Loading…</p>}
                  {!modalExtraLoading && transcript?.error && <p className="bc-muted">No transcript for this video.</p>}
                  {!modalExtraLoading && transcript && !transcript.error && (
                    <pre className="bc-transcript-pre">{typeof transcript === 'string' ? transcript : JSON.stringify(transcript, null, 2)}</pre>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Boclips;
